import { useRoomCapacity as useCommonRoomCapacity } from "@/components/features/items/edit/room/_shared/ui/_components/capacity/_hooks/use-capacity";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomCapacity = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { capacityAdultMaximum, capacityKidsMaximum, capacityPeopleMaximum, isKidsUnavailable } = viewModel;

	return useCommonRoomCapacity({
		capacityAdultMaximum,
		capacityKidsMaximum,
		capacityPeopleMaximum,
		isKidsUnavailable,
		onSetViewModel,
	});
};
